import React, {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {useParams, withRouter} from "react-router-dom";
import './Chat.css';
import ChatList from "./ChatList";
import ChatMain from "./ChatMain";
import ChatClient from "./ChatClient";
import {
  formatErrors,
  UPDATE_CHAT_ACTIVE,
  UPDATE_CHAT_FILTER,
  UPDATE_CHAT_SETTINGS
} from "../../constants";
import {SvgSprite} from "../../utils/svgSprite/SvgSprite";
import {clientGetOneChatAction} from "../../actions/clientAction";
import {toast} from "react-toastify";

const Chat = (props) => {

  const {client_id} = useParams();
  const dispatch = useDispatch();

  if (client_id) {
    dispatch(clientGetOneChatAction(client_id)).then((data) => {
      dispatch({type: UPDATE_CHAT_ACTIVE, chat: data.item});
    }).catch(err => {
      toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  }

  useEffect(() => {
    let curFilter = localStorage.getItem('dc_currentChatFilter');
    if (curFilter) {
      curFilter = JSON.parse(curFilter);
      dispatch({type: UPDATE_CHAT_FILTER, data: curFilter});
    }

    let curSettings = localStorage.getItem('dc_currentChatSettings');
    if (curSettings) {
      curSettings = JSON.parse(curSettings);
      dispatch({type: UPDATE_CHAT_SETTINGS, settings: curSettings});
    }

    if (!client_id) {
      let curChat = localStorage.getItem('dc_currentChat');
      if (curChat) {
        curChat = JSON.parse(curChat);
        dispatch({type: UPDATE_CHAT_ACTIVE, chat: curChat});
      }
    }

    return () => dispatch({type: UPDATE_CHAT_ACTIVE, chat: null});
  }, [dispatch]);

  return <React.Fragment>
        <SvgSprite />
        <div className="content content--flex">
    <ChatList/>

    <ChatMain/>

    <ChatClient/>
  </div>
  </React.Fragment>;
}

export default withRouter(Chat)
